import { cevir } from "@/lib/dil";

/** D-074 Faz 5 · PR 24 (K17): Finishing ve Documents'ın boya raporu cümleleri. Türkçeleri tr-elle.tsv'de "# D-074 Faz 5 · PR 24" altında. */
export type BoyaFinalSecimi = "" | "evet" | "hayir";

/** Etkiler (yükleme penceresi ve Documents "Effects of filing"); seçim yoksa boş. */
export function boyaEtkileri(o: { rn: string; secim: BoyaFinalSecimi; mevcutFinalAd: string | null; asmVar: boolean }): string[] {
  if (o.secim === "") return [];
  if (o.secim === "hayir") return [
    cevir("Kept on record as a non-final coating report. Riser Documentation 3.6, the Dashboard and maintenance completion use only the final."),
    ...(o.mevcutFinalAd ? [] : [cevir("{0} has no final coating report yet; choose it on the Finishing screen.", o.rn)]),
  ];
  if (o.mevcutFinalAd) return [
    cevir("Replaces the final coating report “{0}”; it stays on record as a non-final report.", o.mevcutFinalAd),
    cevir("Riser Documentation 3.6 and the Dashboard use the new final."),
    o.asmVar ? cevir("Maintenance stays completed.") : cevir("Maintenance completes when the assembly report is also uploaded."),
  ];
  return [
    cevir("Filed as the final coating report of {0}: Riser Documentation 3.6 and the Dashboard use it.", o.rn),
    o.asmVar ? cevir("The assembly report is uploaded: OASIS writes “maintenance completed” and the riser moves to MRB document preparation.") : cevir("Maintenance completes when the assembly report is also uploaded."),
  ];
}

/** "Set as final" onayı. */
export function finalYapOnayi(o: { rn: string; ad: string; mevcutFinalAd: string | null; asmVar: boolean }): string {
  if (o.mevcutFinalAd) return cevir("Make “{0}” the final coating report of {1}? It replaces “{2}”, which stays on record as a non-final report. Riser Documentation 3.6 will use “{0}”.", o.ad, o.rn, o.mevcutFinalAd);
  return `${cevir("Make “{0}” the final coating report of {1}? Riser Documentation 3.6 will use it.", o.ad, o.rn)} ${o.asmVar ? cevir("The assembly report is uploaded: OASIS writes “maintenance completed” and the riser moves to MRB document preparation.") : cevir("Maintenance completes when the assembly report is also uploaded.")}`;
}

/** ✕ onayı. */
export function boyaKaldirOnayi(o: { rn: string; ad: string; final: boolean; tamam: boolean }): string {
  if (!o.final) return cevir("Remove the coating report “{0}”? It is not the final report; nothing else changes. The removal is kept in the audit log.", o.ad);
  return `${cevir("Remove the final coating report “{0}”? {1} has no final coating report until another one is set as final; the other reports stay. The removal is kept in the audit log.", o.ad, o.rn)}${o.tamam ? ` ${cevir("Maintenance completion is withdrawn.")}` : ""}`;
}

/**
 * Riserin final boya raporu (set_durum.boya_raporu) ekranda: etkilerin adı ve `oncekiFinal` anahtarı. Anahtar sunucunun
 * `boyaFinalAnahtari`'yla aynıdır: listede final işaretli satırın kimliği; listede satırı olmayan eski final JSON'unda belge kimliği
 * (B7). Belge kimliği tek başına yetmez: aynı PDF'in iki aralığı iki ayrı rapordur.
 */
export type BoyaMevcutFinal = { dosya: string; anahtar: string } | null;

/** Finishing satırının mevcut finali: set'in final JSON'u ve satırın boya raporu listesi. */
export function boyaMevcutFinali(boyaRaporu: { dosya: string; dokumanId: string } | null | undefined, raporlar: readonly { id: string; final: boolean }[]): BoyaMevcutFinal {
  if (!boyaRaporu) return null;
  return { dosya: boyaRaporu.dosya, anahtar: raporlar.find((r) => r.final)?.id ?? boyaRaporu.dokumanId ?? "" };
}

/** Yükleme isteğinin final alanları: `final` her zaman; final seçildiyse ekranın gördüğü finalin anahtarı (`oncekiFinal`, yoksa ""). */
export function boyaFinalAlanlari(secim: "evet" | "hayir", mevcutFinal: BoyaMevcutFinal): Record<string, string> {
  return secim === "evet" ? { final: "true", oncekiFinal: mevcutFinal?.anahtar ?? "" } : { final: "false" };
}

/** "Set as final" isteği: yol ve gövde (ekranın gördüğü finalin anahtarı). */
export function finalYapIstegi(rn: string, raporId: string, mevcutFinal: BoyaMevcutFinal): { yol: string; govde: { oncekiFinal: string } } {
  return { yol: `/assembly/${rn}/boya/${raporId}/final`, govde: { oncekiFinal: mevcutFinal?.anahtar ?? "" } };
}

/** Başlıktaki öteki raporlar çipi. */
export const digerRaporMetni = (n: number): string => (n === 1 ? cevir("+1 report") : cevir("+{0} reports", n));
